export const CASH_FUND_TYPE = 'CASH_FUND';
export const RETAILER_PRODUCT_TYPE = 'RETAILER_PRODUCT';
export const TRANSACTIONAL_PRODUCT_TYPE = 'TRANSACTIONAL_PRODUCT';
export const INTERNAL_GIFT_CARD_PRODUCT_TYPE = 'INTERNAL_GIFT_CARD';
export const UNIVERSAL_REGISTRY_PRODUCT_TYPE = 'UNIVERSAL_REGISTRY_PRODUCT';
export const CASH_FUND_UNLIMITED = 'unlimited';
export const CASH_FUND_FIXED = 'fixed';
export const TK_CASH_REGISTRY_ID = 19999;
export const THIRD_PARTY_GIFT_CARD_TYPE_TEXT = 'Gift Card';
export const MUAF_PURCHASE_INFO_SOURCE = 'Marked purchased by guest';
